import {
  createCollectionURL,
  DELETE_MULTIPLE_ASSET,
  ListofCollectionsURL,
} from 'components/Dam/DAM_API/urls';
import { DAM_SVG } from 'components/Dam/DamAssets';
import Axios, { header } from 'functions/Axios';
import React, { Fragment, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import MoveToAssetDesign from './MoveToAssetDesign';
import AddToCollectionCommonModal from './AddToCollection';
import ShareAssetSection from './ShareAsset';
import { Deletemodel } from 'Common/Deletemodel';
import { useDownloadAssets } from 'context/DownloadAssetsContext';
const SelectionActions = ({
  handleDelete,
  selectedCount,
  downloadImages,
  collectiondataadd,
  HandleAssetMove,
  shareMultipleAsset,
  HandleFolderCreation,
}) => {
  const { selectedAssets, selectedFolders } = useSelector((state) => state.dam);
  const [addcollection, setaddcollection] = useState(false);
  const [datacollection, setDatacollection] = useState();
  const [movetoModal, setMovetoModal] = useState(false);
  const [shareModal, setShareModal] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);

  const { startDownload } = useDownloadAssets();

  const [deleteModalContent, setDeleteModalContent] = useState({
    Header: 'Delete',
    Content: 'Are you sure you want to delete?',
    isCloseButton: false,
  });
  const [deleteLoading, setDeleteLoading] = useState(false);

  const countValue =
    (selectedAssets?.filter((item) => item?.isSelected)?.length ?? 0) +
    (selectedFolders?.filter((item) => item?.isSelected)?.length ?? 0);

  const deletedHandler = async () => {
    try {
      setDeleteLoading(true);
      setTimeout(() => {
        setOpenDeleteModal(false);
      }, 4000);
      const result = await Axios.post(DELETE_MULTIPLE_ASSET, {
        fileId: selectedAssets
          ?.filter((item) => item?.isSelected)
          ?.map((item) => item?.damFileId ?? item?.assetId),
        folderId: selectedFolders?.filter((item) => item?.isSelected)?.map((item) => item?.id),
      });
      setOpenDeleteModal(false);
      setDeleteLoading(false);
      toast.success(result?.data?.message || 'Deleted Successfully');

      handleDelete && handleDelete();
    } catch (error) {
      setOpenDeleteModal(false);
      setDeleteLoading(false);
      console.error(error);
    }
  };

  const downloadHandler = async () => {
    try {

      var _data = {
          fileId: selectedAssets
            ?.filter((item) => item?.isSelected)
            ?.map((item) => item?.damFileId ?? item?.assetId),
          folderId: selectedFolders?.filter((item) => item?.isSelected)?.map((item) => item?.id),
        }

       await startDownload(_data)

    } catch (error) {
      console.error(error);
      const customMessage = error?.response?.headers['x-custom-message'];

      if (customMessage) {
        // toast.error(customMessage);
        setOpenDeleteModal(true);
        setDeleteModalContent({
          Header: 'Warning',
          Content: customMessage,
          isCloseButton: true,
        });
      }
    }
  };

  const fetchCollection = async () => {
    try {
      const response = await Axios.get(ListofCollectionsURL + `?pageNo=${0}&rowSize=20`);
      if (!response.data.errorStatus) {
        setDatacollection(response?.data?.data?.collections);
      } else {
        // Handle error
      }
    } catch (error) {
      // Handle error
    }
  };

  useEffect(() => {
    fetchCollection();
  }, []);
  return (
    <Fragment>
      {addcollection && (
        <AddToCollectionCommonModal
          openModal={addcollection}
          Data={[
            ...(selectedAssets?.filter((item) => item?.isSelected).map((item) => item?.damFileId) ||
              []),
            ...(selectedFolders?.filter((item) => item?.isSelected).map((item) => item?.id) || []),
          ]}
          ToggleModal={() => {
            setaddcollection(!addcollection);
          }}
        />
      )}

      {openDeleteModal && (
        <Deletemodel
          deletemodal={openDeleteModal}
          toggledelete={() => {
            setOpenDeleteModal(!openDeleteModal);
          }}
          handleDelete={deletedHandler}
          loading={deleteLoading}
          Header={deleteModalContent?.Header}
          Content={deleteModalContent?.Content}
          isCloseButton={deleteModalContent?.isCloseButton}
        />
      )}

      {movetoModal && (
        <MoveToAssetDesign
          OpenModal={movetoModal}
          ToggleModal={() => {
            setMovetoModal(!movetoModal);
          }}
          Data={[
            ...(selectedAssets?.filter((item) => item?.isSelected).map((item) => item?.damFileId) ||
              []),
            ...(selectedFolders?.filter((item) => item?.isSelected).map((item) => item?.id) || []),
          ]}
          HandleAssetMove={() => {
            HandleAssetMove && HandleAssetMove();
          }}
          HandleFolderCreation={() => {
            HandleFolderCreation && HandleFolderCreation();
          }}
          isMultiple={true}
        />
      )}

      {shareModal && (
        <ShareAssetSection
          openModal={shareModal}
          ParentId={[
            ...(selectedAssets
              ?.filter((item) => item?.isSelected)
              .map((item) => item?.damFileId ?? item?.assetId) || []),
            ...(selectedFolders?.filter((item) => item?.isSelected).map((item) => item?.id) || []),
          ]}
          toggleOpenModal={() => {
            setShareModal(!shareModal);
          }}
        />
      )}
      <div className="d-flex width-fit-content">
        <div
          className="d-flex align-items-center gap-2 justify-content-center gap-1 pointer Tertiary-Button large-button"
          onClick={() => {
            setOpenDeleteModal(true);
            setDeleteModalContent({
              Header: 'Delete',
              Content: 'Are you sure you want to delete?',
              isCloseButton: false,
            });
          }}
        >
          {/* <img src={deleteicon} alt="Delete Icon" /> */}
          {DAM_SVG.redDeleteIconSvgComponent}
          <div
            className="text-red"
            style={{
              color: '#BE5454',
            }}
          >
            Delete({countValue})
          </div>
        </div>
        <div
          className="d-flex align-items-center gap-2 justify-content-center gap-1 pointer Tertiary-Button large-button"
          onClick={() => {
            setMovetoModal(!movetoModal);
          }}
        >
          {/* <img src={deleteicon} alt="Delete Icon" /> */}
          {DAM_SVG.moveIconSvg}
          <div
            style={{
              color: '#753CB7',
            }}
          >
            Move
          </div>
        </div>
        <div
          className="d-flex align-items-center gap-2 justify-content-center gap-1 pointer Tertiary-Button large-button"
          onClick={downloadHandler}
        >
          {DAM_SVG.inheritDownloadIcons}
          <div
            className=""
            style={{
              color: '#753CB7',
            }}
          >
            Download({countValue})
          </div>
        </div>

        {selectedFolders?.filter((item) => item?.isSelected)?.length === 0 && (
          <div
            className="d-flex align-items-center gap-2 justify-content-center gap-1 pointer Tertiary-Button large-button"
            onClick={() => {
              setaddcollection(true);
              collectiondataadd && collectiondataadd();
            }}
          >
            {DAM_SVG.addiitonSvgIcon}
            <div
              className=""
              style={{
                color: '#753CB7',
              }}
            >
              Add to Collection
            </div>
          </div>
        )}
        <div
          className="d-flex align-items-center gap-2 justify-content-center gap-1 pointer Primary-Button large-button"
          onClick={() => {
            setShareModal(!shareModal);
          }}
        >
          {DAM_SVG.shareIconSvgComponent}
          <div className="">Share</div>
        </div>
      </div>
    </Fragment>
  );
};

export default SelectionActions;
